import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import SpinnerContainer from './components/Utilities/Ui/SpinnerContainer';
import { Route, Routes } from 'react-router-dom';
import OuterLayout from './components/OuterLayout';
import NonWizardLayout from './components/NonWizardLayout';
import Layout from './components/Layout';
import Outline from './components/Outline/Outline';
import MapImport from './components/Outline/MapImport';
import CatchmentContext from './components/CatchmentContext/CatchmentContext';
import Enterprises from './components/Enterprises/Enterprises';
import InfrastructureMap from './components/Infrastructure/InfrastructureMap';
import InfrastructureRisk from './components/Infrastructure/InfrastructureRisk';
import ExternalOrganisation from './components/ExternalOrganisation/ExternalOrganisation';
import EditExternalOrganisation from './components/ExternalOrganisation/EditExternalOrganisation';
import CreateExternalOrganisation from './components/ExternalOrganisation/CreateExternalOrganisation';
import User from './components/User/User';
import AccessManager from './components/User/AccessManager';
import CreateUser from './components/User/CreateUser';
import EditUser from './components/User/EditUser';
import Farm from './components/Farm/Farm';
import CreateFarm from './components/Farm/CreateFarm';
import EditFarm from './components/Farm/EditFarm';
import UserFarm from './components/UserFarm/UserFarm';
import FarmSettings from './components/Farm/FarmSettings';
import Subscriptions from './components/Subscriptions/Subscriptions';
import ViewSubscription from './components/Subscriptions/ViewSubscription';
import News from './components/News/News';
import CreateNews from './components/News/CreateNews';
import EditNews from './components/News/EditNews';
import Unauthorized from './components/Utilities/Errors/Unauthorized';
import NotFound from './components/Utilities/Errors/NotFound';
import RequireAuth from './components/Utilities/RequireAuth/RequireAuth';
import Login from './components/Utilities/Auth/Login';
import Stripe from './components/Utilities/Auth/Stripe';
import Signup from './components/Utilities/Auth/Signup';
import SignupThanks from './components/Utilities/Auth/SignupThanks';
import ResetPassword from './components/Utilities/Auth/ResetPassword';
import ChangePwd from './components/Utilities/Auth/ChangePwd';
import TestAuth from "./components/Utilities/Errors/TestAuth";
import TestAuthOrg from "./components/Utilities/Errors/TestAuthOrg";
import Lmu from './components/Lmu/Lmu';
import ContaminantEvaluation from './components/ContaminantEvaluation/ContaminantEvaluation';
import Ghg from './components/Ghg/Ghg';
import GhgComplete from './components/Ghg/GHGComplete';
import Waterways from './components/Waterways/Waterways';
import WaterwaysMap from './components/Waterways/WaterwaysMap';
import WaterwaysRisk from './components/Waterways/WaterwaysRisk';
import LandSoil from './components/LandSoil/LandSoil';
import Cropping from './components/Cropping/Cropping';
import EffluentDisposal from './components/EffluentDisposal/EffluentDisposal';
import EffluentDisposalRisk from './components/EffluentDisposal/EffluentDisposalRisk';
import EffluentDisposalMap from './components/EffluentDisposal/EffluentDisposalMap';
import MahingaKai from './components/MahingaKai/MahingaKai';
import FreshWaterIrrigation from './components/FreshWaterIrrigation/FreshWaterIrrigation';
import FreshWaterIrrigationRisk from './components/FreshWaterIrrigation/FreshWaterIrrigationRisk';
import FreshWaterIrrigationMap from './components/FreshWaterIrrigation/FreshWaterIrrigationMap';
import MyInfo from './components/MyInfo/MyInfo';
import ViewNews from './components/MyInfo/ViewNews';
import FarmSelector from './components/Farm/FarmSelector';
import Biodiversity from './components/Biodiversity/Biodiversity';
import Biosecurity from './components/Biosecurity/Biosecurity';
import Nutrients from './components/Nutrients/Nutrients';
import Summary from './components/Summary/Summary';
import RiskMap from './components/RiskMap/RiskMap';
import Home  from "./components/Home";
import WinterGrazing from "./components/WinterGrazing/WinterGrazing";
import LmuUpload from "./components/Uploads/LmuUpload";
import ShapeUpload from "./components/UserKMLUpload/ShapeUpload";
import AllFarmsSummary from './components/AllFarmsSummary/AllFarmsSummary';
import EnterpriseInsights from './components/EnterpriseInsights/EnterpriseInsights';
import './custom.css';
import './common.css';
import useAuth from "./components/Utilities/Hooks/useAuth";
import RiskSummary from './components/RiskMap/RiskSummary';
import ChangePassword from './components/User/ChangePassword';
import Risk from './components/RiskSummary/RiskSummary';
import Welcome from "./components/Welcome";
import toast, { Toaster } from 'react-hot-toast';
import FarmSubscriptions from './components/Subscriptions/FarmSubscription';
import ViewFarmSubscriptions from './components/Subscriptions/ViewFarmSubscription';
import SuccessScreen from './components/Subscriptions/SuccessScreen';
import { apiGet, apiPost } from "./components/Utilities/Hooks/apiWrapper";
const ROLES = {
    'Admin': 1,
    'OrgUser': 2,
    'EntityUser': 3,
}

function App() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [farmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId] = useState(localStorage.getItem("loggedInUserId"));
    const [wizardDetails, setWizardDetails] = useState([]);
    const [pageReload, setpageReload] = useState(true);
    const { auth, setAuth } = useAuth();

    useEffect(() => {
        //if (auth != null) {
        //    axios.defaults.headers.common['Authorization'] = `Bearer ${auth.token}`;
        //}
        setLoading(true);
        OnPageload();
    }, [])

    const OnPageload = async (e) => {
        try {
            let response = await axios.get(
                '/api/wizard/GetWizardDetails/', {
                params: {
                    farmId: farmId == 'null' ? 0 : farmId
                }
            }
            );
            setLoading(false);
            setWizardDetails(response.data);
            window.wizardDetails = response.data.wizardItemList;
            window.wizardDetailsV1 = response.data;
            setpageReload(!pageReload)
            var landingPage = response.data.landingPage;
            if (window.location.pathname != '/changepwd') {
                response = await apiGet(
                    '/api/settings/GetUsersWithoutToken/', {
                        params: { Id: userId }
                }
                );
                var user = {};
                if (response.data != null) {
                    user = response.data.content.users.filter(x => x.id == userId);
                    if (user != null) {
                    }
                }
                if (window.location.pathname == '/' || window.location.pathname.toLowerCase() == '/home') {
                    if (user != null) {
                        if (user[0].tcAccepted && user[0].userFarmList.length > 0) {
                            window.open(landingPage, "_self");
                        }
                        else if (user[0].userFarmList.length == 0) {
                            toast.error("Sorry, this user does not have any farm allocated to access. Please contact admin team", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                        }
                    }
                }
                else if (window.location.pathname == '/enterprises' || window.location.pathname == '/catchmentcontext' || window.location.pathname == '/outline' || window.location.pathname == '/lmu' ||
                    window.location.pathname == '/infrastructure' || window.location.pathname == '/waterways' || window.location.pathname == '/mahingakai' || window.location.pathname == '/risk' ||
                    /*window.location.pathname == '/infrastructurerisk' || window.location.pathname == '/waterwaysrisk' ||*/
                    window.location.pathname == '/landsoil' || window.location.pathname == '/nutrients' || window.location.pathname == '/cropping' || window.location.pathname == '/wintergrazing'
                    || window.location.pathname == '/biodiversity' || window.location.pathname == '/ghg'
                    || window.location.pathname == '/summary' || window.location.pathname == '/effluentdisposal' || window.location.pathname == '/freshwaterirrigation' || window.location.pathname == '/waterways'
                ) {
                    if (window.wizardDetailsV1.landingPage.replace('/', '') != window.location.pathname.replace('/', '')) {
                        if (window.wizardDetailsV1.wizardItemList.filter(x => x.controllerName == window.location.pathname.replace('/', '') && x.isSectionCompleted == false).length > 0) {
                            navigate(-1);
                        }
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleWizardChanged = async (section) => {
        let form = {
            farmId: farmId,
            section: section,
            userId: userId,
        }
        try {
            const response = await apiPost(
                '/api/wizard/UpdateWizardDetails/',
                JSON.stringify(form),{
                    params: {
                        farmId: farmId,
                        section: section,
                        userId: userId
                    },
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                if (response.data.status == true) {
                    const redirectURL = response.data.content.redirectURL;
                    const wizardModel = response.data.content.wizardModel;
                    setWizardDetails(wizardModel);
                    setpageReload(!pageReload);
                    window.open(redirectURL, "_self");
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }

    }

    const handleWizardChangedBack = async (section) => {
        let form = {
            farmId: farmId,
            section: section,
            userId: userId,
        }
        try {
            const response = await apiPost(
                '/api/wizard/UpdateWizardDetailsBack/',
                JSON.stringify(form), {
                params: {
                    farmId: farmId,
                    section: section,
                    userId: userId
                },
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
            if (response.data != null) {
                if (response.data.status == true) {
                    const redirectURL = response.data.content.redirectURL;
                    const wizardModel = response.data.content.wizardModel;
                    setWizardDetails(wizardModel);
                    setpageReload(!pageReload);
                    window.open(redirectURL, "_self");
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }

    }

    const handleMoveToNextPage = async (section) => {
        let form = {
            farmId: farmId,
            section: section,
            userId: userId,
        }
        try {
            const response = await apiPost(
                '/api/wizard/MoveToNextPage/',
                JSON.stringify(form), {
                params: {
                    farmId: farmId,
                    section: section,
                    userId: userId
                },
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
            if (response.data != null) {
                if (response.data.status == true) {
                    const redirectURL = response.data.content.redirectURL;
                    setpageReload(!pageReload);
                    window.open(redirectURL, "_self");
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }

    }

    const handleWizardFarmChanged = async (farmid) => {

        try {
            const response = await apiGet(
                '/api/wizard/GetWizardDetails/', {
                params: {
                    farmId: farmid
                }
            }
            );
            if (response.data != null) {
                var landingPage = response.data.landingPage;
                setWizardDetails(response.data)
                window.open(landingPage, "_self");
            }
        } catch (error) {
           
            console.error('Error:', error);
        }

    }

    return (
        loading
            ? <SpinnerContainer />
            : <Routes>
                <Route exact path="/" element={<OuterLayout />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/stripe" element={<Stripe />} />
                    <Route path="/signupthanks" element={<SignupThanks />} />
                    <Route path="/resetpassword" element={<ResetPassword />} />
                    <Route path="/changepwd" element={<ChangePwd />} />
                    {/*<Route path="/changepwd" element={<ChangePassword />} />*/}
                    <Route path="/notfound" element={<NotFound />} />
                    <Route element={<Layout handleWizardFarmChanged={handleWizardFarmChanged}  wizardDetails={wizardDetails} pageReload={pageReload}/>}>
                        <Route path="/unauthorized" element={<Unauthorized />} />                        
                        <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
                            <Route path="/testauth" element={<TestAuth />} />
                        </Route>
                        <Route element={<RequireAuth allowedRoles={[ROLES.OrgUser]} />}>
                            <Route path="/testauthorg" element={<TestAuthOrg />} />
                        </Route>
                        <Route element={<RequireAuth allowedRoles={[ROLES.Admin, ROLES.EntityUser, ROLES.OrgUser]} />}>
                            <Route path="/" element={<Welcome handleWizardFarmChanged={handleWizardFarmChanged} />} />
                            <Route path="/outline" element={<Outline handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/catchmentcontext" element={<CatchmentContext handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/enterprises" element={<Enterprises handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/infrastructure" element={<InfrastructureMap handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/waterways" element={<WaterwaysMap handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/landsoil" element={<LandSoil handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/effluentdisposal" element={<EffluentDisposalMap handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/freshwaterirrigation" element={<FreshWaterIrrigationMap handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/biodiversity" element={<Biodiversity handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/biosecurity" element={<Biosecurity handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/mahingakai" element={<MahingaKai handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/lmu" element={<Lmu handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/contaminantevaluation" element={<ContaminantEvaluation handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/cropping" element={<Cropping handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/ghg" element={<Ghg handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/ghgcomplete" element={<GhgComplete handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/nutrients" element={<Nutrients handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/wintergrazing" element={<WinterGrazing handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/summary" element={<Summary handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/riskmap" element={<RiskMap handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/risksummary" element={<RiskSummary handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/risk" element={<Risk handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/infrastructurerisk" element={<InfrastructureRisk handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/waterwaysrisk" element={<WaterwaysRisk handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/effluentdisposalrisk" element={<EffluentDisposalRisk handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                            <Route path="/freshwaterirrigationrisk" element={<FreshWaterIrrigationRisk handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                        </Route>
                    </Route>
                    <Route element={<NonWizardLayout />}>
                        <Route element={<RequireAuth allowedRoles={[ROLES.Admin, ROLES.EntityUser, ROLES.OrgUser]} />}>
                            <Route path="/Welcome" element={<Welcome handleWizardFarmChanged={handleWizardFarmChanged} />} />
                            <Route path="/farmselector" element={<FarmSelector handleWizardFarmChanged={handleWizardFarmChanged} />} />
                            <Route path="/allfarmssummary" element={<AllFarmsSummary handleWizardFarmChanged={handleWizardFarmChanged} />} />
                            <Route path="/enterpriseinsights" element={<EnterpriseInsights handleWizardFarmChanged={handleWizardFarmChanged} />} />
                        </Route>
                        <Route path="/home" element={<Welcome handleWizardFarmChanged={handleWizardFarmChanged} />} />
                        <Route path="/externalorganisation" element={<ExternalOrganisation />} />
                        <Route path="/editexternalorganisation" element={<EditExternalOrganisation />} />
                        <Route path="/createexternalorganisation" element={<CreateExternalOrganisation />} />
                        <Route path="/user" element={<User />} />
                        <Route path="/accessmanager" element={<AccessManager handleWizardFarmChanged={handleWizardFarmChanged} />} />
                        <Route path="/createuser" element={<CreateUser />} />
                        <Route path="/edituser" element={<EditUser />} />
                        <Route path="/farm" element={<Farm />} />
                        <Route path="/createfarm" element={<CreateFarm />} />
                        <Route path="/editfarm" element={<EditFarm />} />
                        <Route path="/news" element={<News />} />
                        <Route path="/subscriptions" element={<Subscriptions />} />
                        <Route path="/renew-success" element={<SuccessScreen />} />
                        <Route path="/viewsubscription" element={<ViewSubscription />} />
                        <Route path="/farm-subscription" element={<FarmSubscriptions />} />
                        <Route path="/farm-subscription/watch/:id" element={<ViewFarmSubscriptions />} />
                        <Route path="/createnews" element={<CreateNews />} />
                        <Route path="/editnews" element={<EditNews />} />
                        <Route path="/userfarm" element={<UserFarm />} />
                        <Route path="/farmsettings" element={<FarmSettings handleWizardFarmChanged={handleWizardFarmChanged} />} />
                        <Route path="/mapimport" element={<ShapeUpload />} />
                        <Route path="/myinfo" element={<MyInfo />} />
                        <Route path="/viewnews" element={<ViewNews />} />
                        <Route path="/lmuupload" element={<LmuUpload />} />
                        <Route path="/shapeUpload" element={<ShapeUpload />} />
                        <Route path="/changepassword" element={<ChangePassword />} />
                    </Route>
                </Route>
            </Routes>
    );
}

export default App;